define([
	"csi/config",
	"dojo/_base/declare",
	"csi/action/FormData",
	"csi/table/AggregateFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"./BOMSectionMixin",
	"./PartMaterialBOMSectionMixin",
	"./PartMaterialRequireSectionMixin"
], function (config, declare, FormData, AggregateFrom, ActionControllerMixin, xml,
				 Query, BOMSectionMixin, PartMaterialBOMSectionMixin, PartMaterialRequireSectionMixin) {

	return declare([AggregateFrom, ActionControllerMixin, BOMSectionMixin,
		PartMaterialBOMSectionMixin, PartMaterialRequireSectionMixin], {
		// FormData: form data used for processing (comes from page which was "Finished")
		_fdPage: null,

		/**
		 * Add UsableForStyleBOM or UsableForMaterialBOM  and season availability filters
		 * @override
		 */
		applyActionFilters: function (view) {
			let q = new Query();
			this._applyUsableFilters(q);
			this._applySeasonAvailabilityFilters(q);
			view.relRoot.addQuery(q);
			this.inherited(arguments);
		},

		/**
		 * Filter by season availability if on Style BOM for first page
		 * @override
		 */
		getWizardViewQuery: function (wizard, view, index) {
			const q = new Query();

			q.importQuery(this._actionViewParameters.m_fixedQuery);
			this._applyUsableFilters(q);

			let groupProductType = this.widget.getActionElementGroupProductType(this);
			if (groupProductType) {
				q.RefAttr("ProductType", xml.OP_EQUALS, groupProductType);
			}

			if (index === 0) {
				// filter by season availability if on Style BOM
				this._applySeasonAvailabilityFilters(q);
			}

			return q;
		},

		/**
		 * Prepare the data and pass it into the next page
		 * @param {csi.wizard.Widget} wizard
		 * @param {csi.wizard.Content} currentPage
		 * @param {csi.wizard.Content} nextPage
		 * @param {boolean} bFinish
		 * @returns {*|null}
		 */
		onNextPage: function (wizard, currentPage, nextPage, bFinish) {
			if (bFinish) {
				// if finished, track form data to use for writing operations
				this._fdPage = currentPage.getPageData();
				return null;
			} else if (nextPage.getPageData()) {
				// nothing to do if form data already exists for page
				return null;
			}

			// create form data for each page
			return wizard.setFormDataToPage(nextPage, new FormData(this), false);
		},

		/**
		 * Filter by season availability if on Style BOM
		 * @override
		 */
		_getActionViewParameters: function (ctx, h, ren) {
			const p = this.inherited(arguments);
			const parentType = this.getParentType(ctx);
			const query = p.m_fixedQuery;

			const isRowAction = !this.actionWidget || this.actionWidget.pluginName !== "ToolbarNewActions";

			if (isRowAction) {
				const qr = this.widget.getQueryResultByDomNode(this.refNode);
				this.applyBomSectionQuery(qr.parentResult.groupValue, query, this.m_cache);
			} else {
				this._applyRequireSectionFiltersFromMaterial(query);
			}

			if (!this._isSeasonAvailabilityEnforced()) {
				//DE16031: New from Material dialog does not need to be a wizard selection in Material BOM
				p.m_viewRef.m_id = parentType === "ApparelBOMRevision" ? "SelectMaterialWizard" : "MaterialsView";
			}
			return p;
		},

		_processFormData: function (/*FormData*/fd) {
			return this.inherited(arguments, [this._fdPage || fd]);
		},

		/**
		 * Returns Parent type of the context
		 * @param {Context} ctx
		 */
		getParentType: function (/*Context*/ctx) {
			return ctx ? ctx.getParent().$Type : null;
		},

		postProcessSuccess() {
			const cache = this.getCache();
			const bom = cache.getNode(this.getParent().__Parent__);
			const isRequireSection = config.getSubtypeSetting(bom.Subtype, "RequireSectionForPlacement");
			if (isRequireSection) {
				this.widget.refreshData();
			} else {
				this.inherited(arguments);
			}
		}
	});
});